// tokenDB.js
import { openDB } from "idb";

const DB_NAME = "AuthDB";
const STORE_NAME = "auth";

// Utility to open the database
async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

// Set a single key-value pair
export async function setAuthItem(key, value) {
  const db = await getDB();
  return db.put(STORE_NAME, value, key);
}

// Get a value by key
export async function getAuthItem(key) {
  const db = await getDB();
  return db.get(STORE_NAME, key);
}

// Remove a key
export async function removeAuthItem(key) {
  const db = await getDB();
  return db.delete(STORE_NAME, key);
}

// Clear all auth data
export async function clearAuthData() {
  const db = await getDB();
  return db.clear(STORE_NAME);
}
